import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-community-fullview',
  template: 'Testing',
  standalone: true,
  imports: [CommonModule],
})
export class CommunityFullViewComponent {


}
